import Field from 'components/Form/Field';
import KeyValue from 'components/Layout/KeyValue';
import Value from 'components/Value';
import {SupersendContact} from 'pages/History/SendingOrders/Details/types';
import {FC} from 'react';
import {t} from 'ttag';

type TeamNotificationsProps = {
    className?: string;
    notificationRecipients?: SupersendContact[];
};
const TeamNotifications: FC<TeamNotificationsProps> = ({
    className,
    notificationRecipients,
}) => {
    if (!notificationRecipients || notificationRecipients.length === 0) {
        return null;
    }
    return (
        <div className={className}>
            <hr className="my-4" />
            <KeyValue keyWidth={10}>
                <Field
                    label={t`Team Notification`}
                    tooltip={{
                        href: 'https://help.makeleaps.jp/ja/articles/5746705-faq-送付前確認画面の-通知先-とは何ですか',
                        message: t`Who receives the account notifications related to the sending activities?`,
                    }}
                    type="value"
                >
                    <Value
                        value={{
                            type: 'tags',
                            value: notificationRecipients.map((recipient) => ({
                                color: 'blue',
                                label: recipient.name || '-',
                                tooltip: recipient.email,
                            })),
                        }}
                    />
                </Field>
            </KeyValue>
        </div>
    );
};

export default TeamNotifications;
